import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import { SecondaryTitle } from '@generators/htmlComponents/SecondaryTitle'
import { Line } from '@generators//htmlComponents/Line'

import { Textarea } from './styles'

const styles = ({
  container: {
    marginTop: 30,
    marginBottom: 14,
  },
})

const AutoGrowTextarea = ({ value, disabled }) => {
  const textareaRef = useRef(null)

  useEffect(() => {
    adjustTextareaHeight()
  }, [value])

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  return (
    <div style={styles.container}>
      <SecondaryTitle text="Prontuário" />
      <Textarea ref={textareaRef} value={value} disabled={disabled} />
      <Line />
    </div>
  )
}

AutoGrowTextarea.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
}

AutoGrowTextarea.defaultProps = {
  value: '',
  disabled: false,
}

export default AutoGrowTextarea
